import axios from 'axios'

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL
})

class API {

    /**
     * @param {any} pollData
     * @param {File} thumbnail
     */
    async createPoll(pollData, thumbnail) {
        if (!thumbnail) {
            return (await api.post(`/poll/`, pollData)).data
        }

        const formData = new FormData()
        formData.append('thumbnail', thumbnail)
        for (const [key, value] of Object.entries(pollData)) {
            formData.append(key, value)
        }

        return (
            await api.post(`/poll/`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
        ).data
    }

    /**
     * @param {string} id
     * @param {string} tangledIdemGUID
     */
    async getPoll(id, tangledIdemGUID = undefined) {
        return (await api.get(`/poll/${id}/${tangledIdemGUID ? `?tangledIdemGUID=${tangledIdemGUID}` : ''}`)).data
    }

    /**
     * @param {string} id
     * @param {any} pollData
     * @param {File} thumbnail
     */
    async updatePoll(id, pollData, thumbnail = undefined) {
        if (!thumbnail) {
            return (await api.put(`/poll/${id}/`, pollData)).data
        }

        const formData = new FormData()
        formData.append('thumbnail', thumbnail)
        for (const [key, value] of Object.entries(pollData)) {
            formData.append(key, value)
        }

        return (
            await api.put(`/poll/${id}/`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
        ).data
    }

    /**
     * @param {string} tangledIdemGUID
     * @param {string} statusCode
     */
    async getUserPolls(tangledIdemGUID, statusCode) {
        return (await api.get(`/poll/?statusCode=${statusCode}&tangledIdemGUID=${tangledIdemGUID}`)).data
    }

    /**
     * @param {string} tangledIdemGUID
     */
    async userHasPolls(tangledIdemGUID) {
        return (await api.get(`/user/${tangledIdemGUID}/has-poll/`)).data
    }

    /**
     * @param {string} id
     */
    async getVotes(id) {
        return (await api.get(`/poll/${id}/vote/`)).data
    }

    /**
     * @param {string} id
     * @param {string} tangledIdemGUID
     */
    async deletePoll(id, tangledIdemGUID) {
        return (await api.delete(`/poll/${id}/?tangledIdemGUID=${tangledIdemGUID}`)).data
    }

    /**
     * @param {string} id
     * @param {string} tangledIdemGUID
     */
    async closePoll(id, tangledIdemGUID) {
        return (await api.put(`/poll/${id}/`, { status: 2, tangledIdemGUID })).data
    }

    /**
     * @param {string} id
     * @param {string} option
     * @param {string} tangledIdemGUID
     * @param {string} tangledUserName
     * @param {string} tangledLedgerGUID
     */
    async castVote(id, option, tangledIdemGUID, tangledUserName, tangledLedgerGUID) {
        return (await api.post(`/poll/${id}/vote/`, { tangledIdemGUID, tangledUserName, tangledLedgerGUID, option })).data
    }

    /**
     * @param {any} userData
     */
    async upsertUser(userData) {
        return (await api.post(`/user/`, userData)).data
    }
}

export default new API;
